import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "w-full px-4" };
const _hoisted_2 = {
    key: 0,
    class: "overflow-x-auto"
};
const _hoisted_3 = { class: "min-w-full bg-white border border-gray-200" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("thead", { class: "bg-gray-50" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r" }, " ID "),
        /*#__PURE__*/ _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r" }, " 名前 "),
        /*#__PURE__*/ _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b" }, " メールアドレス ")
    ])
], -1);
const _hoisted_5 = { class: "divide-y divide-gray-200" };
const _hoisted_6 = { class: "px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 border-r border-gray-200" };
const _hoisted_7 = { class: "px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 border-r border-gray-200" };
const _hoisted_8 = { class: "px-4 py-3 whitespace-nowrap text-sm text-gray-600" };
const _hoisted_9 = /*#__PURE__*/ _createTextVNode(" キャンセル ");
import { computed } from 'vue';
import DialogModal from '@/Common/DialogModal.vue';
import WhiteButton from '@/Common/Button.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        show: null,
        selectedUsers: null,
        mode: null
    },
    emits: ['close', 'action'],
    setup(__props, { emit }) {
        const props = __props;
        // モードに応じたタイトル
        const modalTitle = computed(() => (props.mode === 'add'
            ? '選択したユーザに模試を追加する'
            : '選択したユーザの模試を削除する'));
        // モードに応じたボタンテキスト
        const actionButtonText = computed(() => (props.mode === 'add' ? '追加' : '削除'));
        // モードに応じたボタンスタイル
        const actionButtonClass = computed(() => (props.mode === 'add'
            ? 'bg-blue-600 text-blue-50'
            : 'bg-red-600 text-red-50'));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DialogModal, {
                show: __props.show,
                "max-width": "lg",
                onClose: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('close')))
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(modalTitle)), 1)
                ]),
                content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (__props.selectedUsers.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("table", _hoisted_3, [
                                    _hoisted_4,
                                    _createElementVNode("tbody", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedUsers, (user) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: user.id,
                                                class: "hover:bg-gray-50"
                                            }, [
                                                _createElementVNode("td", _hoisted_6, _toDisplayString(user.id), 1),
                                                _createElementVNode("td", _hoisted_7, _toDisplayString(user.name), 1),
                                                _createElementVNode("td", _hoisted_8, _toDisplayString(user.email), 1)
                                            ]));
                                        }), 128))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                footer: _withCtx(() => [
                    _createVNode(WhiteButton, {
                        class: "mr-4 bg-white text-black",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_9
                        ]),
                        _: 1
                    }),
                    _createElementVNode("button", {
                        class: _normalizeClass([_unref(actionButtonClass), "px-8 py-2 rounded max-w-max shadow-sm hover:shadow-lg"]),
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('action')))
                    }, _toDisplayString(_unref(actionButtonText)), 3)
                ]),
                _: 1
            }, 8, ["show"]));
        };
    }
});
